import { render, staticRenderFns } from "./pendaftarBmtk.vue?vue&type=template&id=fd47ce86"
import script from "./pendaftarBmtk.vue?vue&type=script&lang=js"
export * from "./pendaftarBmtk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports